export default "__VITE_ASSET__DBQSNB33__"